import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Document } from '../models/document';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Document> {
    return this.getWithRest("id/" + id);
  }

  private getWithRest(rest_url: string) : Promise<Document> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'document_controller/' + rest_url).subscribe((response:any) => {
      if(response.type == 'document' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
}

}
